module.exports = __webpack_public_path__ + "static/media/loanApplicationWhite.4baaeb64.svg";